import React from "react";
import { ChannelContext } from "../contexts";
import "../assets/styles/header.sass";
import Utility from "../Utility";
import Socials from "./Socials";
import { Link } from "react-router-dom";
const Header = ({ content }) => {
  return (
    <ChannelContext.Consumer>
      {(currentChannel) => (
        <div className="ur-mini-header ur-mini-container">
          <Link
            to={Utility.getChannelUrl(content, currentChannel)}
            className="ur-mini-logo"
          >
            <div
              style={{
                backgroundImage: `url(${Utility.getChannelHeaderLogo(
                  content,
                  currentChannel
                )})`,
              }}
            ></div>
          </Link>
          <div>
            <Socials content={content} />
          </div>
        </div>
      )}
    </ChannelContext.Consumer>
  );
};
export default Header;
